export default {"src":"/_next/static/image/public/images/language/de.0d7b8d972b3fd5c4301ab23f4728602c.svg","height":18,"width":18};